
import Animation from 'Scripts/classes/Animation'
//Vendor
import SplitType from 'split-type'
import gsap from 'gsap'

export default class extends Animation {
  constructor({ element }) {

    super({
      element,
      elements : {
        text : new SplitType(element, { types: 'lines' })
      }
    })
  }

  animateIn() {
    super.animateIn()

    gsap.set(this.element, { autoAlpha: 1 })
    gsap.to(this.elements.text.lines, {
      autoAlpha: 1,
      y: '0%',
      stagger: 0.05      
    })

  }

  animateOut() {
    super.animateOut()
    
    gsap.set(this.element, { autoAlpha: 0})  
    gsap.set(this.elements.text.lines, {
      autoAlpha: 0,
      y: '100%'
    })
  }

}
